/**
 * @generated SignedSource<<72e3c0e9075e17eec46e970031c3eb3d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RelatedQuestions_question$data = {
  readonly relatedQuestions: ReadonlyArray<{
    readonly answerCount: number | null;
    readonly title: string | null;
    readonly url: string | null;
  } | null> | null;
  readonly " $fragmentType": "RelatedQuestions_question";
};
export type RelatedQuestions_question$key = {
  readonly " $data"?: RelatedQuestions_question$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelatedQuestions_question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RelatedQuestions_question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuestionType",
      "kind": "LinkedField",
      "name": "relatedQuestions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "answerCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuestionType",
  "abstractKey": null
};

(node as any).hash = "b104b0c25fdef359acee8f9f93c99b70";

export default node;
